import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "./Home";
import Admin from "./Admin";
import ProductDetail from "./ProductDetail";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/product/:id" element={<ProductDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
